import React from 'react';

import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import dataFaq from '../assets/fake-data/data-faq';
import Action from '../components/layouts/Action';
import FAQ2 from '../components/layouts/FAQ2';
import MetaCircleVisualization from '../components/MetaCircleVisualization';


const RoadMapMain = () => {
    const sampleData = [
        { holdings: 16260000000, wallets: 388, name: '>10M ADA', color: { r: 0.1, g: 0.3, b: 0.8, a: 1 } },
        { holdings: 5510000000, wallets: 2377, name: '1M-10M ADA', color: { r: 0.2, g: 0.6, b: 0.9, a: 1 } },
        { holdings: 5570000000, wallets: 21744, name: '100K-1M ADA', color: { r: 0.3, g: 0.8, b: 1, a: 1 } },
        { holdings: 3430000000, wallets: 123051, name: '10K-100K ADA', color: { r: 0.6, g: 0.9, b: 0.4, a: 1 } },
        { holdings: 1260000000, wallets: 392721, name: '1K-10K ADA', color: { r: 1, g: 0.8, b: 0.2, a: 1 } },
        { holdings: 213240000, wallets: 566505, name: '100-1K ADA', color: { r: 1, g: 0.5, b: 0.1, a: 1 } },
        { holdings: 22430000, wallets: 597952, name: '10-100 ADA', color: { r: 0.9, g: 0.2, b: 0.2, a: 1 } }
    ];

    return (
        <div className='roadmap'>
            <Header />
      
            <section className="tf-section metacircle-section">
                <div className="container">
                    <div className="col-md-12">
                        <div className="text-center mb-50">
                            <h3 className="sub-title mb-20">Interactive Graphic Data Visualization</h3>
                            <p className="fs-18">Use your mouse to move the circles around. Overlapping circles will turn pink. </p>
                        </div>
                        <div className="metacircle-container">
                            <MetaCircleVisualization 
                                data={sampleData}
                                totalSupply={32265670000}
                                backgroundColor="#233b68ff"
                                width={1200}
                                height={600}
                                config={{
                                    scaleFactor: 7500,  // Much higher to reduce circle count
                                    minRadius: 3,
                                    maxRadius: 400,
                                    margin: 150
                                }}
                                onCircleClick={(data) => {
                                    console.log('Clicked category:', data.name);
                                }}
                                onCircleHover={(data, event, type) => {
                                    if (type === 'enter') {
                                        console.log('Hovering over:', data.name);
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </section>
         
    
            <FAQ2 data={dataFaq} />
            <Action />
            <Footer />
        </div>
    );
}

export default RoadMapMain;